var cov_ldynbvpr7 = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/AnimationList/styles/index.ts",
      hash = "c7c5328c8b468ebc18a0b0123bbbe827ec96c7e9",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/AnimationList/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 25
        },
        end: {
          line: 5,
          column: 53
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


import genaration from '../../utils/classname';
var listLess = {};
export var listClass = (cov_ldynbvpr7.s[0]++, genaration(listLess, 'list'));